import './App.css';

function MarketingMenuItem({
    title
}) {
    return (
        <div
            className='mkv2-menu-item'
        >
            {title}
        </div>
    );
}

export default MarketingMenuItem;